export const AnchorLinks = (function () {
	'use strict';

	let $win, $anchorLink;

	function init() {
		$win = jQuery(window);
		$anchorLink = $('a');

		if (location.hash) {
			if ($(location.hash).length > 0) {
				window.addEventListener("load", (event) => {
					scrollToEl(location.hash);
				});
			}
		}

		$anchorLink.on('click',function (event) {
			let id = $(this).prop('hash');
			console.log(id)
			if (id.length > 1 &&  $(id).length > 0) {
				scrollToEl(id);
			}
		});
	}

	function scrollToEl(id) {
		let headerHeight = $('.site-header').outerHeight();

		$('html, body').stop().animate({
				scrollTop: $(id).offset().top - headerHeight,
		},1000);
	}

	return {
		init: init,
	};
})();
